import React from "react";
import styles from "../styles/habitaciones.module.css";

export default function HabitacionFormModal({
    open,
    editing,
    formData,
    onChange,
    onClose,
    onSubmit,
}) {
    if (!open) return null;

    return (
        <div className={styles["modal-overlay"]}>
            <div className={styles["modal-content"]}>
                <form className={styles.card} onSubmit={onSubmit}>
                    <h3 style={{ marginTop: 0 }}>
                        {editing ? "Editar habitación" : "Nueva habitación"}
                    </h3>

                    <div className={styles["grid-2"]}>
                        <div className={styles.field}>
                            <label className={styles.label}>Nombre</label>
                            <input
                                type="text"
                                name="nombre"
                                value={formData.nombre}
                                onChange={onChange}
                                required
                            />
                        </div>

                        <div className={styles.field}>
                            <label className={styles.label}>Disponible</label>
                            <label className={`${styles.switch} ${styles.inline}`}>
                                <input
                                    type="checkbox"
                                    name="disponible"
                                    checked={!!formData.disponible}
                                    onChange={onChange}
                                />
                                <span>Marcar como disponible</span>
                            </label>
                        </div>
                    </div>

                    <div className={styles.field}>
                        <label className={styles.label}>Descripción</label>
                        <textarea
                            name="descripcion"
                            value={formData.descripcion}
                            onChange={onChange}
                            placeholder="Detalles rápidos de la habitación…"
                        />
                    </div>

                    <div className={styles.field}>
                        <label className={styles.label}>Comentarios</label>
                        <textarea
                            name="comentarios"
                            value={formData.comentarios}
                            onChange={onChange}
                            placeholder="Notas internas (opcional)…"
                        />
                    </div>

                    <div className={styles["item-actions"]}>
                        <button
                            type="button"
                            className={`${styles.btn} ${styles.ghost}`}
                            onClick={onClose}
                        >
                            Cancelar
                        </button>
                        <button type="submit" className={`${styles.btn} ${styles.primary}`}>
                            Guardar
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
